import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlButtonElement } from "./HtmlButtonElement";
import { HtmlController } from "../HtmlController";
import { PlayList } from "../../Components/Sounds/PlayList";
import { DataManager } from "../../Managers/DataManager";
import { AppContext } from "../../../Common/AppContext";
import { AutoplayConfirmationDialog } from "../../Channels/Common/Dialogs/AutoplayConfirmationDialog";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlAutoplayItemButtonElement extends HtmlButtonElement {
    autoplayCount: string = "∞";

    constructor() {
        super();
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    create(node: Element): void {
        super.create(node);

        if (node.hasAttribute("AUTOPLAY_COUNT")) {
            this.autoplayCount = node.getAttribute("AUTOPLAY_COUNT");
        }
    }

    onClick(e?: Event): void {
        const event = e;

        if (AppContext && AppContext.gameConfiguration.AutoplayConfirmationEnabled) {
            PlayList.play("SND_Click");
            AutoplayConfirmationDialog.openDialog(parseInt(this.autoplayCount), () => {
                this.runAutoplay(event);
            });
        } else {
            this.runAutoplay(event);
        }
    }

    private runAutoplay(e: Event): void {
        if (this.autoplayCount != null) {
            DataManager.AutoplayCount = this.autoplayCount;
        }
        PlayList.play("SND_Click");
        super.onClick(e);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Elements/HtmlAutoplayItemButtonElement.ts
 **/